"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.has = void 0;
const get_path_segments_1 = require("./get-path-segments");
const is_object_1 = require("./is-object");
const is_string_1 = require("./is-string");
exports.has = (object, path) => {
    if (!is_object_1.isObject(object) || !is_string_1.isString(path)) {
        return false;
    }
    const pathSegments = get_path_segments_1.getPathSegments(path);
    for (let i = 0; i < pathSegments.length; i++) {
        if (!is_object_1.isObject(object)) {
            return false;
        }
        if (!(pathSegments[i] in object)) {
            return false;
        }
        object = object[pathSegments[i]];
    }
    return true;
};
//# sourceMappingURL=has.js.map